export default "__VITE_ASSET__Dcvat59s__"